//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Tabs from '@/components/Tabs';
import DigitalCapacity from '@/components/Hall/DigitalCapacity';
import hum from 'humanize-duration';
import Vlogin from '../../components/popUp';
import api from '../../api';

export default {
    components: {Tabs, DigitalCapacity, Vlogin},
    mounted() {
        const id = this.$route.query.id;
        if (id) {
            this.id = id;
            this.getDtail();
            if (this.isLogin) {
                this.getQualificationState();
            }
        }
        const wx = this.$wechat;
        const link = window.location.href;
        const self = this;
        api.vega.wechat.getJsSdkSignature({url: location.href.split("#")[0]})
            .then(res => {
                const data = res.data.data;
                wx.config({
                    debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                    appId: data.appid, // 必填，公众号的唯一标识
                    timestamp: data.timestamp, // 必填，生成签名的时间戳
                    nonceStr: data.noncestr, // 必填，生成签名的随机串
                    signature: data.signature,// 必填，签名
                    jsApiList: [
                        "onMenuShareTimeline",
                        "onMenuShareAppMessage"
                    ] // 必填，需要使用的JS接口列表
                });
                wx.ready(function () {   //需在用户可能点击分享按钮前就先调用
                    // wx.updateAppMessageShareData({
                    //     title: document.title, // 分享标题
                    //     desc: document.title, // 分享描述
                    //     link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    //     imgUrl: data.wxShareData.imgUrl, // 分享图标
                    //     success: function () {
                    //     // 设置成功
                    //     }
                    // });
                    wx.onMenuShareAppMessage({
                        title: self.detailData.title,
                        desc: self.detailData.orgname,
                        link: link,
                        imgUrl: self.detailData.logo, // 发布招标信息公司的logo
                        trigger: function (res) {
                        },
                        success: function (res) {
                        },
                        cancel: function (res) {
                        },
                        fail: function (res) {
                        }
                    });
                    wx.onMenuShareTimeline({
                        title: self.detailData.title,
                        desc: self.detailData.orgname,
                        link: link,
                        imgUrl: self.detailData.logo, // 发布招标信息公司的logo
                        trigger: function (res) {
                        },
                        success: function (res) {
                        },
                        cancel: function (res) {
                        },
                        fail: function (res) {
                        }
                    });
                });
            })
        // 添加监听滚动事件
        window.addEventListener('scroll', this.handleScroll)

    },
    data: () => ({
        nowDate: new Date(),
        isEnd: false,
        qState: {}, // 招标单车队报名资质认证状态
        tabsDatas: [
            {text: '招标说明', key: 'tenderExplain'},
            {text: '车队要求', key: 'carsRequire'},
            {text: '联系方式', key: 'contact'},
        ],
        tabKey: 'tenderExplain',
        id: '',
        detailData: {},
        certificateOptions: [
            {label: '营业执照（三证合一）', value: '2'},
            {label: '道路运输许可证', value: '3'},
            {label: '开户许可证', value: '4'},
            {label: '年度货物运输险', value: '5'},
        ],
        carrierState: 0, // 当前登录用户与招标单的关系状态
        fixedTitle: false, // 悬浮标题显示隐藏
    }),
    computed: {
        allDic() {
            return this.$store.state.allDic;
        },
        isLogin() {
            return this.$store.state.isLogin;
        },
        companyStatus() {
            return this.$store.state.companyStatus || 0;
        },
    },
    methods: {
        tabClick(activeKey) {
            let dom = document.querySelector(`#${activeKey}`).offsetTop - 90;
            window.scrollTo({
                top: dom,
                behavior: "smooth"
            });
            this.tabKey = activeKey;
        },
        getDtail() {
            api.vega.tender.detail({
                tenderId: this.id,
            }).then((res) => {
                const data = res.data.data;
                this.detailData = data;
                this.carrierState = data.carrierState;
            });
        },
        goodsType(type) {
            let goodsType = '--';
            if (this.allDic['goodsType']) {
                this.allDic['goodsType'].children.map((item) => {
                    if (`${type}` === item.id) {
                        goodsType = item.value;
                    }
                    return item;
                })
            }
            return goodsType;
        },
        findRate(str) {
            const strArr = [];
            if (str) {
                const arr = str.split(',');
                for (let i = 0; i < arr.length; i++) {
                    const item = `${parseFloat(arr[i], 10) * 100}%`;
                    strArr.push(item);
                }
            }
            return strArr.join('，');
        },
        findRequired(str) { // 查询证件要求
            if (str) {
                const arr = str.split(',');
                const arr2 = [];
                for (let i = 0; i < arr.length; i++) {
                    const item = arr[i];
                    for (let j = 0; j < this.certificateOptions.length; j++) {
                        const _item = this.certificateOptions[j];
                        if (item === _item.value) {
                            arr2.push(_item.label);
                        }
                    }
                }
                return arr2.join('，');
            }
        },
        leftTime(time = '') {
            let diff = '';
            const end = new Date(time.replace(/-/g, '/'));
            diff = Math.floor((end.getTime() - this.nowDate.getTime()) / 1000);
            if (diff <= 0) {
                this.isEnd = true;
            } else if (diff > 0) {
                this.isEnd = false;
            }
            return this.getLeveTime(diff);
        },
        getLeveTime(r) {
            let t = '';
            if (r - 0 === 0) {
                return 0;
            }
            if (r) {
                t = hum(r * 1000, {
                    language: 'zh_CN',
                    delimiter: ' ',
                    largest: 2,
                }).replace(/\s/g, '');
            }
            return t;
        },
        getQualificationState() {
            api.vega.tender.qualificationState({id: this.id}).then((res) => {
                const data = res.data.data;
                this.qState = data;
            })
        },
        signUp() {
            // if (!this.isLogin) {
            //     this.$vux.toast.text('请先登录');
            //     this.$store.commit('updateIsPopLogin', true);
            //     return;
            // }
            // if (this.isEnd) {
            //     return;
            // }
            // const { businessPaperState, transportPaperState, accountPaperState, regAmountState, regYearsState, taxrateState, insurancePaperState } = this.qState;
            // if (regAmountState !==0 && regAmountState === 2) {
            //     this.$vux.toast.text('抱歉, 您的注册资金未通过');
            //     return;
            // }
            // if (regYearsState !==0 && regYearsState === 2) {
            //     this.$vux.toast.text('抱歉, 您的注册年限未通过');
            //     return;
            // }
            // if (businessPaperState !==0 && businessPaperState === 2) {
            //     this.$vux.toast.text('营业执照（三证合一）不通过,请完善资质');
            //     return;
            // }
            // if (transportPaperState !==0 && transportPaperState === 2) {
            //     this.$vux.toast.text('道路运输许可证 不通过,请完善资质');
            //     return;
            // }
            // if (accountPaperState !==0 && accountPaperState === 2) {
            //     this.$vux.toast.text('开户许可证 不通过,请完善资质');
            //     return;
            // }
            // if (taxrateState !==0 && taxrateState === 2) {
            //     this.$vux.toast.text('发票要求 不通过,请完善资质');
            //     return;
            // }
            // if (insurancePaperState !==0 && insurancePaperState === 2) {
            //     this.$vux.toast.text('年度货物运输险 不通过,请完善资质');
            //     return;
            // }
            // this.$vux.toast.text('请选择联系人');
            this.$router.push({
                name: 'hall.confirmApplication',
                query: {
                    id: this.id,
                }
            })
        },
        handleScroll() { //改变元素#searchBar的top值
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop; // 滚动距离顶部的距离
            const tabScrollBar = document.querySelector('#tabScrollBar').offsetTop - document.querySelector('#fixed-title').offsetHeight;// 元素距离顶部的距离
            const fixedTitle = document.querySelector('#fixedTitle').offsetTop;// 元素距离顶部的距离
            const tenderExplain = document.querySelectorAll('.background-white')[0].offsetTop + document.querySelectorAll('.background-white')[0].offsetHeight - 90;// 元素距离顶部的距离
            const carsRequire = document.querySelectorAll('.background-white')[1].offsetTop + document.querySelectorAll('.background-white')[1].offsetHeight - 90;// 元素距离顶部的距离
            if (scrollTop >= tenderExplain && scrollTop <= carsRequire) {
                this.tabKey = 'carsRequire'
            } else if (scrollTop >= carsRequire) {
                this.tabKey = 'contact'
            } else {
                this.tabKey = 'tenderExplain'
            }
            if (scrollTop >= tabScrollBar) {
                document.querySelector('#tabScrollBar').classList.add("tab-fixed");
            }
            if (scrollTop >= fixedTitle) {
                this.fixedTitle = true;
            } else {
                this.fixedTitle = false;
                document.querySelector('#tabScrollBar').classList.remove("tab-fixed");
            }
        },
        download(url) {
            if (url !== '') {
                // const newTab = window.open('about:blank');
                // newTab.location.href = url;
                location.href = url;
            }
        },
    },
    destroyed() { //离开该页面需要移除这个监听的事件
        window.removeEventListener('scroll', this.handleScroll)
    },
};
